import RewardDetailsPageContainer from "./reward-details.container";

export default RewardDetailsPageContainer;